<div class="step-content">
  <section class="step-section" [formGroup]="form">
    <h1 class="h1-heading">{{ title }}</h1>

    @if (control) {
      <ul class="list-unstyled" formArrayName="corporateHoldersAuthorisedSignatories">
        @for (holder of corporateHolders; track holder; let index = $index) {
          @if (form.controls.corporateHoldersAuthorisedSignatories.controls[index]) {
            <li class="form-group">
              <div class="mb-1">Authorised Signatories: {{ holder.name }}</div>
              <app-auth-signatory
                tip="Add Authorised Signatories’ names separated by semicolon"
                [authSignatoriesControl]="form.controls.corporateHoldersAuthorisedSignatories.controls[index]"
                [corporateHolders]="corporateHoldersAll"
                [relationshipId]="holder.relationshipId"
                [details]="holder.details"
                [holderName]="holder.name"
                [isPosted]="holder.isPosted"
                [customErrors]="authSignatoriesCustomErrors"
                [controlLike]="true"
                (onDataSaved)="onDataSaved($event, holder)"
              />
            </li>
          }
        }
      </ul>
    }
  </section>
</div>
